import { useState, useRef } from "react";
import cls from "classnames";

import useScrollHeight from "@qoohoo/common/hooks/useScrollHeight";

const About = ({ channelDetails }) => {
  const descRef = useRef(<div></div>);
  const [showMore, setShowMore] = useState(false);
  const isVisible = useScrollHeight(descRef);

  return (
    <>
      {channelDetails.description && (
        <h2 className="mt-12 text-xl font-medium sm:mt-14 md:mt-16 sm:text-2xl font-inter">
          {`About Channel`}
        </h2>
      )}
      <p
        ref={descRef}
        className={cls(
          "text-sm sm:text-base text-[#F0F0F0] whitespace-pre-wrap font-nunito",
          {
            "mt-3 sm:mt-4": !!channelDetails.description,
            "line-clamp-none": showMore,
            "line-clamp-8": !showMore,
          }
        )}
      >
        {channelDetails.description}
      </p>
      {isVisible && (
        <button
          onClick={() => setShowMore(!showMore)}
          className="mt-2 font-semibold hover:opacity-90"
        >
          {showMore ? "Show Less" : "Show More"}
        </button>
      )}
    </>
  );
};

export default About;
